import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var RefreshCw = createReactComponent("RefreshCw", ["svg", defaultAttributes, [["path", {
  d: "M21 2v6h-6",
  key: "1vq7dv"
}], ["path", {
  d: "M3 12a9 9 0 0115-6.7L21 8",
  key: "48bf8d"
}], ["path", {
  d: "M3 22v-6h6",
  key: "y8mpgs"
}], ["path", {
  d: "M21 12a9 9 0 01-15 6.7L3 16",
  key: "qnxswy"
}]]]);
export default RefreshCw;